export default {
  userRegisteredCard: {
    myWorkTitle: "My Registered Cards",
    useBankCardText:
      "Please note, for Rial deposits, only use the registered bank cards. Otherwise, your transaction will be suspended."
  }
};
